export const getProductUrl = product_id => st.urlWithCurrentQuery(`${st.GLOBALS.BACKEND_URL}p/${product_id}`)

export const getNewOrderUrl = ({ product_id, product_variant_id, product_schedule_slot_id }) => {
  const params = jQuery.param({
    pv_id: product_variant_id,
    slot_id: product_schedule_slot_id,
  })
  return st.urlWithCurrentQuery(`${st.GLOBALS.BACKEND_URL}p/${product_id}/rezerwuj?${params}`)
}


// WEBPACK FOOTER //
// ./app/webpack/shared/utils/routes.js